import React from "react";

import SignupForm from "../components/SignupForm";
import Navbar from "../components/Navbar";

export default function Signup() {
  return (
    <div style={{ padding: "2rem" }}>
      <Navbar />
      <SignupForm />
    </div>
  );
}
